import React, {useEffect} from 'react';
import NoticiasCompletas from '../NoticiaCompleta/index'
import CFDI from './ImagenesMuestra/CFDI.png';
import interes1 from './ImagenesMuestra/CFDI2.png'
import './styles.css'



export default function NoticiaCFDI(props){
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return(<>
    <NoticiasCompletas
    encabezado={'Conoce la nueva versión del CFDI 4.0'}
    categoria={'Facturación electrónica'}
    fecha={'Enero 2022'}
    texto={'La nueva versión del CFDI 4.0 entró en vigor a partir del 1 de enero de 2022. Entérate de lo que este cambio significa para poder emitir las facturas electrónicas cumpliendo con la última actualización fiscal. A partir de la fecha obligatoria fijada por el SAT para adoptar el nuevo formato de facturación en 2022, los proveedores de timbrado deberán migrar o hacer todos los cambios necesarios en sus plataformas para adaptarse al CFDI 4.0, por lo que será mejor mantenerse al día en su sistema de facturación online. Los cambios más importantes que se implementan en los Comprobantes Fiscales Digitales por Internet (CFDI) son que: Se especificarán el nombre y el domicilio fiscal del emisor y del receptor de la factura. Indicará si las operaciones amparadas son objeto de impuestos indirectos. Llevará nuevos apartados para informar sobre operaciones con el público en general y las realizadas a cuenta de terceras personas. Podrán identificarse las operaciones donde haya una exportación de mercancías. Y podrán cancelarse las facturas, siempre que se señale la razón de ello y se haga dentro del plazo fijado. La autoridad fiscal dio a conocer que la entrada en vigor de la versión 4.0 del CFDI inicia el 1 de enero de 2022 de manera no obligatoria. Dicha obligatoriedad comenzará el 1 de mayo, lo que significa que los Proveedores Autorizados de Certificación (PAC) tendrán un plazo de adaptación de 4 meses. Cumplido ese periodo, los contribuyentes que no estén facturando bajo el esquema CFDI 4.0 no podrán emitir sus comprobantes fiscales.'}
    portada={CFDI}
    interes1={interes1}
    link1={'/noticiaBeneficiosCFDI'}
    tituloInteres1={'Beneficios CFDI 4.0'}
    />
    <div className='cGeneralVideoNoticia'>
<div className='cVideoNoticia'>
  <div className='cTituloVideoNoticia'>
    Campos necesarios para la versión 4.0
  </div>
<video
    src='https://tytsoftwaredemexico.com/Logos/CFDITT.mp4'
    autoPlay={true}
    muted={true}
    controls={true}
    />
</div>
</div>
    
    </>)
}